<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="deposit_record_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" :alt="$t('invest.DepositRecords')">
            </div>
            <div class="big_tit">{{ $t('invest.DepositRecords') }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 表格头部 -->
            <div class="table_header">
                <div class="header_item">{{ $t('invest.Time') }}</div>
                <div class="header_item">{{ $t('invest.Way') }}</div>
                <div class="header_item">{{ $t('invest.Amount') }}</div>
                <div class="header_item">{{ $t('invest.Status') }}</div>
                <div class="header_item">{{ $t('invest.IsPass') }}</div>
            </div>

            <!-- 记录列表区域 -->
            <div class="records_container">
                <!-- 加载状态 -->
                <div v-if="loading" class="loading_state">
                    <div class="loading_text">{{ $t('item.Loading') }}</div>
                </div>
                
                <!-- 空状态 -->
                <div v-else-if="depositRecords.length === 0" class="empty_state">
                    <div class="empty_text">{{ $t('invest.NoDepositRecord') }}</div>
                </div>
                
                <!-- 记录列表 -->
                <div v-else class="record_list">
                    <div 
                        v-for="record in depositRecords" 
                        :key="record.id" 
                        class="record_item"
                    >
                        <div class="record_time">{{ formatTime(record.time) }}</div>
                        <div class="record_type">{{ record.type }}</div>
                        <div class="record_amount">
                            <div class="amount_main">{{ record.money }}</div>
                        </div>
                        <div class="record_status">
                            <span :class="getStatusClass(record.status)">
                                {{ getStatusText(record.status) }}
                            </span>
                        </div>
                        <div class="record_pass">
                            <span :class="getPassClass(record.warn)">
                                {{ getPassText(record.warn) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "DepositRecord",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            depositRecords: [], // 存储存款记录数据
            loading: false // 加载状态
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        this.getDepositRecords();
    },
    methods: {
        // 获取存款记录
        async getDepositRecords() {
            try {
                this.loading = true;
                console.log('开始获取存款记录...');
                
                // 调用API获取存款记录
                const result = await Fetch('/user/recharge_search');
                
                console.log('存款记录API响应:', result);
                
                if (result && result.code === 1) {
                    console.log('存款记录获取成功:', result.data);
                    this.depositRecords = result.data || [];
                } else if (result && result.code === 0) {
                    console.log('存款记录业务提示:', result);
                    // 显示业务提示信息
                    let message = '';
                    if (typeof result.info === 'string') {
                        message = result.info;
                    } else if (typeof result.info === 'object') {
                        const currentLang = localStorage.getItem('lang') || 'zh_hk';
                        message = result.info[currentLang] || result.info.zh_cn || '暂无记录';
                    }
                    console.log('提示信息:', message);
                    this.depositRecords = [];
                } else {
                    console.error('存款记录获取失败:', result);
                    this.depositRecords = [];
                }
            } catch (error) {
                console.error('获取存款记录出错:', error);
                this.depositRecords = [];
            } finally {
                this.loading = false;
            }
        },
        
        // 格式化时间
        formatTime(timeStr) {
            if (!timeStr || timeStr === '0000-00-00 00:00:00') {
                return '--';
            }
            return timeStr;
        },
        
        // 获取状态样式类
        getStatusClass(status) {
            switch (status) {
                case 0: return 'status_pending';
                case 1: return 'status_success';
                case 2: return 'status_failed';
                default: return 'status_unknown';
            }
        },
        
        // 获取状态文本
        getStatusText(status) {
            switch (status) {
                case 0: return this.$t('invest.Processing');
                case 1: return this.$t('invest.Success');
                case 2: return this.$t('invest.Failed');
                default: return this.$t('invest.Unknown');
            }
        },
        
        // 获取通过状态样式类
        getPassClass(warn) {
            switch (warn) {
                case 0: return 'pass_yes';
                case 1: return 'pass_no';
                default: return 'pass_unknown';
            }
        },
        
        // 获取通过状态文本
        getPassText(warn) {
            switch (warn) {
                case 0: return this.$t('invest.Passed');
                case 1: return this.$t('invest.NotPassed');
                default: return this.$t('invest.Unknown');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.deposit_record_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.main_content {
    flex: 1;
    background: #ffffff;
    padding-top: 54px; // 为固定头部留出空间
    padding-bottom: 80px; // 为底部导航栏留出空间
}

.table_header {
    display: flex;
    // background: #f8f9fa;
    // border-bottom: 1px solid #e9ecef;
    padding: 12px 0;

    .header_item {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #495057;
        padding: 0 8px;
    }
}

.records_container {
    flex: 1;
    min-height: 400px;
    background: #ffffff;
    
    .loading_state {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        
        .loading_text {
            color: #666;
            font-size: 14px;
        }
    }
    
    .empty_state {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        
        .empty_text {
            color: #999;
            font-size: 14px;
        }
    }
    
    .record_list {
        .record_item {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            border-bottom: 1px solid #f0f0f0;
            
            &:last-child {
                border-bottom: none;
            }
            
            .record_time {
                flex: 1;
                font-size: 12px;
                color: #666;
                text-align: center;
            }
            
            .record_type {
                flex: 1;
                font-size: 12px;
                color: #333;
                text-align: center;
            }
            
            .record_amount {
                flex: 1;
                text-align: center;
                
                .amount_main {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500;
                }
                

            }
            
            .record_status {
                flex: 1;
                text-align: center;
                
                .status_pending {
                    color: #ffa500;
                    font-size: 12px;
                }
                
                .status_success {
                    color: #52c41a;
                    font-size: 12px;
                }
                
                .status_failed {
                    color: #ff4d4f;
                    font-size: 12px;
                }
                
                .status_unknown {
                    color: #999;
                    font-size: 12px;
                }
            }
            
            .record_pass {
                flex: 1;
                text-align: center;
                
                .pass_yes {
                    color: #52c41a;
                    font-size: 12px;
                }
                
                .pass_no {
                    color: #ff4d4f;
                    font-size: 12px;
                }
                
                .pass_unknown {
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}

/* 底部导航栏样式已移至FooterTab组件 */
</style> 